import { render, staticRenderFns } from "./SeleccionarTipoImpresion.vue?vue&type=template&id=67123263&scoped=true"
import script from "./SeleccionarTipoImpresion.vue?vue&type=script&lang=js"
export * from "./SeleccionarTipoImpresion.vue?vue&type=script&lang=js"
import style0 from "./SeleccionarTipoImpresion.vue?vue&type=style&index=0&id=67123263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67123263",
  null
  
)

export default component.exports